/* Moses Basket Set - CTA smooth scroll to the buy box (main-product section) */
(function () {
  'use strict';
  if (window.__msbCtaScroll) return;
  window.__msbCtaScroll = true;

  function scrollToMatch(substr) {
    var el = document.querySelector('[id*="' + substr + '"]');
    if (!el) return false;
    var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    el.scrollIntoView({ behavior: behavior, block: 'start' });
    // Move keyboard/screen-reader focus to the buy box, not just the viewport
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
    return true;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a.msb-btn--cta') : null;
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (href.indexOf('#') !== 0) return;
    e.preventDefault();
    if (!scrollToMatch('__main-product')) {
      window.location.hash = href;
    }
  });
})();
